import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Popup, Icon, Image } from 'semantic-ui-react'
import { getSourceUrl } from 'utils/functions'
import css from './ImagePreview.module.sass'

class ImagePreview extends Component {
  constructor () {
    super(...arguments)

    this.state = {
      sourceUrl: ''
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.source !== prevProps.source) {
      this._prepareSourceUrl()
    }
  }

  async _prepareSourceUrl () {
    const { source } = this.props
    const sourceUrl = await getSourceUrl(source)

    this.setState({ sourceUrl })
  }

  render () {
    const { sourceUrl } = this.state

    return (
      <div>
        <Popup
          trigger={<Icon name='image' />}
          position='top center'
          flowing
          hoverable
          on='click'
        >
          <Popup.Content>
            { sourceUrl
              ? <Image
                src={sourceUrl}
                size='tiny'
              />
              : <div className={css.placeholder}>
                <Icon name='image' size='big' />
              </div>
            }
          </Popup.Content>
        </Popup>
        { sourceUrl &&
          <img
            className={css.hidden}
            src={sourceUrl}
            ref={(image) => { this.hiddenImage = image }}
          />
        }
      </div>
    )
  }
}

const { string } = PropTypes

ImagePreview.propTypes = {
  source: string
}

export default ImagePreview



// WEBPACK FOOTER //
// ./src/components/Settings/ImagePreview/ImagePreview.js